const STATE_CODES = {
  // United States
  alabama: "AL", alaska: "AK", arizona: "AZ", arkansas: "AR", california: "CA",
  colorado: "CO", connecticut: "CT", delaware: "DE", "district of columbia": "DC",
  florida: "FL", georgia: "GA", hawaii: "HI", idaho: "ID", illinois: "IL",
  indiana: "IN", iowa: "IA", kansas: "KS", kentucky: "KY", louisiana: "LA",
  maine: "ME", maryland: "MD", massachusetts: "MA", michigan: "MI", minnesota: "MN",
  mississippi: "MS", missouri: "MO", montana: "MT", nebraska: "NE", nevada: "NV",
  "new hampshire": "NH", "new jersey": "NJ", "new mexico": "NM", "new york": "NY",
  "north carolina": "NC", "north dakota": "ND", ohio: "OH", oklahoma: "OK",
  oregon: "OR", pennsylvania: "PA", "rhode island": "RI", "south carolina": "SC",
  "south dakota": "SD", tennessee: "TN", texas: "TX", utah: "UT", vermont: "VT",
  virginia: "VA", washington: "WA", "west virginia": "WV", wisconsin: "WI",
  wyoming: "WY",
  // India
  "andhra pradesh": "AP", "arunachal pradesh": "AR", assam: "AS", bihar: "BR",
  chhattisgarh: "CG", goa: "GA", gujarat: "GJ", haryana: "HR",
  "himachal pradesh": "HP", jharkhand: "JH", karnataka: "KA", kerala: "KL",
  "madhya pradesh": "MP", maharashtra: "MH", manipur: "MN", meghalaya: "ML",
  mizoram: "MZ", nagaland: "NL", odisha: "OD", punjab: "PB", rajasthan: "RJ",
  sikkim: "SK", "tamil nadu": "TN", telangana: "TS", tripura: "TR",
  "uttar pradesh": "UP", uttarakhand: "UK", "west bengal": "WB",
  "andaman and nicobar islands": "AN", chandigarh: "CH",
  "dadra and nagar haveli and daman and diu": "DN", delhi: "DL",
  "jammu and kashmir": "JK", ladakh: "LA", lakshadweep: "LD", puducherry: "PY",
};

// Lookup is name-based because state_mt has no short code column; unknown
// states fall back to the full name.
export function stateShortName(stateName) {
  const name = String(stateName || "").trim();
  if (!name) return "";
  return STATE_CODES[name.toLowerCase()] || name;
}
